<ng-container>
  <div class="content-wrapper">
    <ng-container>
      <app-header version="2"></app-header>
      @if (!this.isProd || this.isInspector) {
        <app-environment></app-environment>
      }
      <div [ngClass]="{'tiles-page-container': !isDashboard() }">
        <router-outlet></router-outlet>
      </div>
      <app-side-bar [@slideInOut]="(sidebarService.status$ | async)" [content]="(sidebarService.content$ | async)"></app-side-bar>
    </ng-container>
    <div class="content-wrapper-push"></div>
  </div>
  <footer><small>&copy; 2023-{{currentYear}} The University of North Carolina at Chapel Hill</small></footer>
</ng-container>



